import { IGroup } from "@app/main/components/resourceManagement/groups/_models/IGroup";
import { IGroupWithIds } from "@app/main/components/resourceManagement/groups/_models/IGroupWithIds";
import { GroupService } from "@services/group.service.ajs";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import "./groupSelector.scss";

export enum AttachmentPosition {
    TopLeft,
    TopRight,
    BottomLeft,
    BottomRight
}

interface IComponentBindings {
    selectedGroup: IGroup;
    resourceCount: number;
    attachmentPosition: string;

    onGroupClicked: (args: { group: IGroup }) => void;
}

class Controller implements angular.IComponentController, IComponentBindings {

    selectedGroup: IGroup;
    resourceCount: number;
    attachmentPosition: string;

    onGroupClicked: (args: { group: IGroup }) => void;

    showGroupFilterDialog: boolean;

    noSelectionLabel: string;
    groups: IGroupWithIds[];

    // ---

    static $inject = ["groupService", "translationService", "$scope"];

    constructor(
        private readonly groupService: GroupService,
        private readonly translationService: TranslationService,
        private readonly $scope: angular.IScope,
    ) {}

    $onInit(): void {
        this.noSelectionLabel = this.translationService.t("groupSelector.all");

        if (this.attachmentPosition === undefined) {
            this.attachmentPosition = AttachmentPosition[AttachmentPosition.TopRight];
            return;
        }

        if (!(typeof this.attachmentPosition === 'number') && AttachmentPosition[this.attachmentPosition] === undefined) {
            console.error(this.attachmentPosition, " isnt valid position", AttachmentPosition[this.attachmentPosition]);
        }
    }

    groupClicked(group: IGroup): void {
        this.selectedGroup = group;
        this.showGroupFilterDialog = false;

        if (this.onGroupClicked) {
            this.onGroupClicked({ group });
        }
    }

    toggleGroupFilterDropDown(): void {
        this.showGroupFilterDialog = !this.showGroupFilterDialog;

        // we need groups updated to see the current group hierarchy
        if (this.showGroupFilterDialog) {
            this.groupService.getGroupsWithFullMappings().then(groups => {
                this.groups = groups;
                this.$scope.$applyAsync();
            });
        }
    }
}

export class GroupSelectorComponent implements angular.IComponentOptions {
    bindings: any;
    template: string;
    controller: any;

    constructor() {
        this.bindings = {
            selectedGroup: "<",
            resourceCount: "<",
            attachmentPosition: "@",
            noSelectionLabel: "@",

            onGroupClicked: "&",
        };

        this.controller = Controller;
        this.template = require("./groupSelector.html");
    }
}
